module.exports = __webpack_public_path__ + "static/5_teddybearcarpet-85547139abba263611ee4df5d89ba03b.jpg";